/* eslint-disable */
const content = {
  component: "PageTypeA",
  cssClass: "page-five",
  meta: {
    title:
      "وصفة النجاح الكبير في Tony’s Chocolonely: مزج أخلاقيات التجارة بالتكنولوجيا السحابية",
    description: `تتصدى شركة Tony’s Chocolonely لمحاربة الاستغلال والرق في صناعة الشوكولاتة. وبفضل التكنولوجيا السحابية، استطاعت الشركة توسيع أعمالها بسرعة وتوفير الشوكولاتة الأخلاقية "الخالية من استعباد الأطفال" للمستهلكين في جميع أنحاء العالم.`,
    og: {
      type: "website",
      title:
        "التكنولوجيا السحابية تدعم الممارسات الأخلاقية في الأعمال - اقرأ المزيد",
      description: `حققت تجارة الشوكولاتة الأخلاقية "والخالية من استعباد الأطفال" التي تنتجها شركة Tony’s Chocolonely رواجًا ضخمًا، لكن هذا النمو الكبير ترافق مع تحديات كبيرة. بفضل استخدام التكنولوجيا السحابية، استطاعت الشركة من إيقاف الوقت المُهدر في استخدام الجداول المحاسبية الإلكترونية، والتركيز على ما تجيد فعله وهو صناعة الشوكولاتة اللذيذة القائمة على المبادئ الأخلاقية. `,
      image: require("../../assets/images/social/fair-trade-high-growth-1200x630.jpg")
    },
    twitter: {
      card: "summary",
      title:
        "اقرأ كيف ساعدت التكنولوجيا السحابية على ازدهار شركة تعتمد التجارة العادلة في صناعة الشوكولاتة",
      description: `ساعدت التكنولوجيا السحابية شركة Tony’s Chocolonely التي تصنع الشوكولاتة الخالية من استعباد الأطفال على توسيع أعمالها ما مكّنها من تسويق منتجاتها الأخلاقية اللذيذة لكل محبي الشوكولاتة في العالم.`,
      site: "@Oracle",
      creator: "@Oracle",
      image: require("../../assets/images/social/fair-trade-high-growth-300x300.jpg")
    }
  },
  title:
    "<span>وصفة النجاح الكبير في Tony’s Chocolonely: مزج أخلاقيات التجارة بالتكنولوجيا السحابية</span>",
  heroImage: {
    preload: require("../../assets/images/bgs/fair-trade-high-growth-pre.jpg"),
    loaded: require("../../assets/images/bgs/fair-trade-high-growth.jpg"),
    mobile: require("../../assets/images/bgs/fair-trade-high-growth-mobile.jpg")
  },
  // * the heroImageOptions are currently only required and supported when using the PageTypeA component
  heroImageOptions: {
    default: {
      customPosition: [true, "center"]
    },
    mobile: {
      customPosition: [true, "top !important"],
      customSize: "100% auto !important"
    },
    limtedHeight: {
      customPosition: [false]
    }
  },
  sections: [
    {
      component: "SectionCopy",
      content: {
        copy: `
        إذا لم تكن من محبي الشوكولاتة، فأنت على الأقل تعرف شخصًا ما يعشقها. قبل نهاية العام الماضي، أنفق عشاق الشوكولاتة حوالي 100 مليار دولار لشراء أكثر من 8 ملايين طن من هذه الحلوى اللذيذة.
        `,
        type: "intro"
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: null
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
        <p>ما لا يعرفه معظمنا أن 70 في المئة من إنتاج الشوكولاتة في العالم، وفق ما جاء في تقرير صادر عن جامعة تولين ووزارة العمل الأمريكية، يأتي من مزارع الكاكاو في غرب أفريقيا، حيث يُجبر الأطفال وأحيانًا غيرهم من ضحايا الرق المعاصر على العمل في ظروف خطرة وغير قانونية.</p>
        <p>بعد الكشف عن هذه الحقيقة المريرة أثناء إنتاج برنامج تلفزيوني قبل أكثر من عشر سنين، أسس الصحفي الاستقصائي الهولندي "توني فان دي كوكن" واثنان من زملائه الصحفيين، شركة "Tony’s Chocolonely، على مبدأ إنتاج "شوكولاتة خالية من استعباد الأطفال"؛ بهدف التأثير على الشركات الأخرى المصنّعة للشوكولاتة لكي تحذو حذوهم.</p>
        <p>من خلال ست جمعيات تعاونية للشركاء في غانا وساحل العاج، تتعامل شركة Tony’s Chocolonely مع 5500 مزارع مستقل لتحسين جودة محاصيلهم باستخدام أحدث الممارسات الزراعية المستدامة. كما توفر للمزارعين فرص التعليم الزراعي مع دفع أجور كافية تكفل لهم حياة كريمة، حتى يتمكنوا من دفع أجور العمال البالغين بدلاً من أطفالهم الذين يذهبون إلى المدارس. وحول هذا يقول "باسكال فان هام"، رئيس قسم التسويق في الشركة: "نحاول أن نكون قدوة لغيرنا، ولدينا رغبة في أن نكون مصدرًا لإلهام الآخرين ليسيروا في الاتجاه الصحيح. لن يُمكننا الوصول إلى شوكولاتة خالية من استعباد الأطفال بنسبة 100% إلا بتعاوننا وتضافر جهودنا المشتركة."</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionQuote",
      content: {
        quote: `نحاول أن نكون قدوة لغيرنا، ولدينا رغبة في أن نكون مصدرًا لإلهام الآخرين ليسيروا في الاتجاه الصحيح. لن نتمكن من تقديم شوكولاتة 100% خالية من استعباد الأطفال إلا بالتضافر المشترَك لجهودنا.`,
        author: `Pascal van Ham`,
        position: `رئيس قسم التسويق, Chocolonely`,
        type: "quote",
        backgroundImage: require("../../assets/images/bgs/FairTradeHighGrowth_Chocolonely_bg.jpg")
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
        <p>هذه الممارسات التجارية فضلاً عن منتجات الشوكولاتة الفخمة قدمت ميزة كبيرة لشركة Tony’s Chocolonely وكانت سببًا جوهريًا في نجاحها وازدهارها. فقد حافظت الشركة التي يوجد مقرها في أمستردام على معدل نمو سنوي بنسبة 50 في المائة منذ أن بدأت أعمالها عام 2005، رغم أنها تدفع فرق سعر مقداره 175 دولارًا لكل طن متري تشتريه من حبوب الكاكاو (أعلى من الأسعار المنشورة وفقًا لمعايير التجارة العادلة). ومنذ عام 2012، زادت إيرادات Tony’s Chocolonely بمعدل تسعة أضعاف لتصل إلى 44.9 مليون يورو (55.3 مليون دولار أمريكي) عام 2017.</p>
        <p>وما كان هذا النمو السريع ليتحقق من دون تحديات. فبينما كانت إيرادات الشركة في ازدياد مستمر، لم تعد برمجيات الجداول المحاسبية، التي كان موظفو المبيعات والمالية يستخدمونها في تسجيل المعاملات المالية، قادرة على مواكبة حجم أعمال الشركة واتساع نشاطها. وكان من الطبيعي حدوث الأخطاء وإعادة تنفيذ بعض المهام مرة أخرى. يقول فريتز سنيل، مسؤول مبيعات الشوكولاتة: "الاستمرار في استخدام الجداول المحاسبية الإلكترونية كان يعني أن موظفي المبيعات يستغرقون معظم وقتهم في إصلاح الأخطاء بدلاً من بيع الشوكولاتة."</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionImage",
      content: {
        image: require("../../assets/images/content/FairTradeHighGrowth_InlineImage.jpg"),
        alt: "",
        type: "image"
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          ولأن شركة Tony’s Chocolonely تشتري حبوب الكاكاو من جمعيات المزارعين الشريكة لها فقط، لا يصبح أمامها سوى بدائل قليلة عندما لا تصيب توقعاتها، الأمر الذي يجعل الحفاظ على الدقة في غاية الأهمية. وعن هذا الأمر يقول فرانس بانكوك، مسؤول منظومة التوريد: "التخطيط التنبؤي هو أمر شديد الحساسية. فمن غير الممكن التوريد من جمعية تعاونية أخرى إذا عجزت إحدى الجمعيات التعاونية الشريكة لنا عن توفير ما يكفي من حبوب الكاكاو."
        `,
        type: "default"
      }
    },
    {
      component: "SectionQuote",
      content: {
        quote: `يقول بانكوك: "تساعدنا تكنولوجيا Oracle Cloud في إعداد توقعات واقعية يمكنني تسليمها لإدارة العمليات حتى يستطيع فريقي بدء العمل مع المورِّدين المناسبين وتسريع تدفق الحبوب". وهذه التوقعات لا تساعد شركة Tony’s Chocolonely على تحقيق أهدافها للنمو فحسب، بل تتيح لها أيضًا الالتزام بالمبادئ الأخلاقية التي قامت عليها علامتها التجارية.`,
        author: `Frans Pannekoek`,
        position: `Supply Chain “Bean to Bar Tender”, Chocolonely`,
        type: "quote"
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `هذه التوقعات لا تساعد شركة Tony’s Chocolonely على تحقيق أهدافها للنمو فحسب، بل تتيح لها أيضًا الالتزام بالمبادئ الأخلاقية التي قامت عليها علامتها التجارية.`,
        type: "default"
      }
    },
    {
      component: "SectionCallToAction",
      content: {
        title: `طوّر أعمالك مع حلول وتكنولوجيا Oracle`,
        ctas: [
          {
            image: require("../../assets/images/svgs/report.svg"),
            copy: `تقرير "صُنّاع القرار والتكنولوجيا"`,
            url:
              "https://www.oracle.com/sa-ar/applications/erp/cfos-digital-bridge-builders.html?source=:ow:o:cs:mt:RC_EMMK181024P00070C0004:YTTFY19_FI_AW_HI_CM_SA_C33_Q33_RT&intcmp=:ow:o:cs:mt:RC_EMMK181024P00070C0004:YTTFY19_FI_AW_HI_CM_SA_C33_Q33_RT",
            buttonCopy: "اقرأ التقرير"
          },
          {
            image: require("../../assets/images/svgs/servers.svg"),
            copy: "جرِّب حلول Oracle Cloud السحابية",
            url:
              "https://go.oracle.com/LP=43623?qt=saas_erp_fin_DeliverDecisiveInsightwithOracleFinancialsCloud&src1=:ow:o:cs:mt:RC_EMMK181024P00070C0004:YTTFY19_FI_CT_QT_CM_SA_C38_Q34&intcmp=WWMK161025P00088:ow:o:cs:mt:RC_EMMK181024P00070C0004:YTTFY19_FI_CT_QT_CM_SA_C38_Q34",
            buttonCopy: "‫جرِّبها الآن‬"
          }
        ],
        type: "cta"
      }
    }
  ]
};

export default content;
